import React, { PureComponent } from 'react'
import Card from '../../../components/Card'
import ActiveWorkOrders from './ActiveWorkOrders'
import CasesShipped from './CasesShipped'
import UnitsByLocation from './UnitsByLocation'

export default class Charts extends PureComponent {
  render () {
    return (
      <div className='flex flex-col gap-5'>
        <div className='grid grid-cols-1 lg:grid-cols-3 gap-5 mt-5'>
          <div className='col-4'>
            <Card>
              <ActiveWorkOrders />
            </Card>
          </div>
          <div className='col-4'>
            <Card>
              <UnitsByLocation />
            </Card>
          </div>
          <div className='col-4'>
          <Card>
            <CasesShipped />
          </Card>
          </div>
        </div>
      </div>
    )
  }
}
